export const API = {
  // Subscription
  ACTIVE_CAR_URL: '/core/api/v1/subscription/bluelink/{vin}/status',
  ACTIVE_PACKAGE_URL: '/core/api/v1/subscription/bluelink/{vin}/active',
  PACKAGE_LIST_URL: '/core/api/v1/subscription/bluelink/{vin}',
  ORDER_DETAIL_URL: '/core/api/v1/subscription/bluelink/order/{planId}',
  TRX_HISTORY_URL: '/core/api/v1/subscription/bluelink/history',
  TRX_HISTORY_DETAIL_URL: '/core/api/v1/subscription/bluelink/history/{id}',
  CANCEL_ORDER_URL: '/core/api/v1/subscription/bluelink/order/{planId}/cancel',
  STOP_AUTO_RENEWAL_URL: '/core/api/v1/subscription/bluelink/order/{planId}/renewal/stop',

  // Subscription DDL
  PERIOD_LIST_URL: '/core/api/v1/subscription/duration/ddl',
  TRX_STATUS_LIST_URL: '/core/api/v1/subscription/status/ddl',
  PACKAGE_NAME_LIST_URL: '/core/api/v1/subscription/plan/ddl',
  PAYMENT_METHOD_LIST_URL: '/core/api/v1/subscription/paymentmethod/ddl',
  PAYMENT_GROUP_LIST_URL: '/core/api/v1/subscription/paymentmethod/group/ddl',

  // Vehicles
  CAR_LIST_URL: '/core/api/v1/vehicles',

  // Inbox (Notifications)
  NOTIFICATIONS_URL: '/core/api/v1/Inbox/Data',
  NOTIFICATION_DETAIL_URL: '/core/api/v1/Inbox/Detail/{id}',
  NOTIFICATION_READ_URL: '/core/api/v1/Inbox/Read/{id}',

  // Promo code
  CHECK_PROMO_CODE_URL: '/core/api/v1/promocode/{code}/check',
  IS_REFERRAL_PROMO_CODE_URL: '/core/api/v1/PromoCode/{code}/IsReferral',

  // Copyright
  COPYRIGHT_URL: '/core/api/v1/copyright/{type}',
  LOCALIZATION_URL: '/core/api/v1/copyright/language/dictionary',

  // Language
  LANGUAGE_LIST_URL: '/core/api/v1/language/ddl',

  // Blob
  DOWNLOAD_URL: '/core/api/v1/blob/download',

  // Session
  SESSION_URL: '/core/api/v1/session/authcode',
  REFRESH_SESSION_URL: '/core/api/v1/session/refresh',

  // Config Item
  IN_APP_POPUP_URL: '/core/api/v1/Config/InAppPopup',

  PENDING_PAYMENT_FEEDBACK: '/core/api/v1/Subscription/Bluelink/History/pendingpaymentfeedback',
  SUBMIT_PAYMENT_FEEDBACK: '/core/api/v1/Subscription/Bluelink/History/submitpaymentfeedback',

  // Referral
  REFERRAL_CODE_URL: '/core/api/v1/ReferralCode',
  REFERRAL_REWARD_DETAIL_URL: '/core/api/v1/ReferralCode/reward/{paymentPkId}'
} as const
